import { useEffect, useRef, useState } from "react";
import { formatFileSize, inventoryFileKey } from "./inventoryUploadUtils";

function PendingFilePreview({ file, kind }) {
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (!file) return undefined;
    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  if (kind === "image" && url) {
    return <img className="inv-pending-thumb" src={url} alt="" />;
  }
  if (kind === "video" && url) {
    return <video className="inv-pending-thumb" src={url} muted playsInline />;
  }
  return <span className="inv-pending-icon">PDF</span>;
}

export default function InventoryUploadField({
  title,
  chooseLabel,
  addMoreLabel,
  accept,
  kind,
  files,
  disabled,
  canAddMore,
  canRemoveBox,
  onAddFiles,
  onRemoveFile,
  onAddBox,
  onRemoveBox,
}) {
  const inputRef = useRef(null);

  const handleChange = (event) => {
    const picked = Array.from(event.target.files || []).filter((file) => file && file.size > 0);
    if (!picked.length) {
      if (event.target.files?.length) {
        alert("Empty files were skipped.");
      }
      event.target.value = "";
      return;
    }
    onAddFiles(picked);
    event.target.value = "";
  };

  return (
    <div className="inv-upload-field">
      <div className="inv-upload-field__head">
        <span className="inv-upload-field__label">{title}</span>
        {canRemoveBox ? (
          <button
            type="button"
            className="inv-box-close"
            disabled={disabled}
            onClick={onRemoveBox}
            aria-label={`Remove ${title}`}
          >
            ×
          </button>
        ) : null}
      </div>

      <label className={`inv-choose-btn inv-choose-btn--${kind}`}>
        {chooseLabel}
        <input
          ref={inputRef}
          className="inv-upload-field__input"
          type="file"
          accept={accept}
          multiple
          disabled={disabled}
          onChange={handleChange}
        />
      </label>

      {files.length === 0 ? (
        <p className="inv-upload-hint">No file selected</p>
      ) : (
        <ul className="inv-pending-files">
          {files.map((file) => (
            <li key={inventoryFileKey(file)} className="inv-pending-files__item">
              <PendingFilePreview file={file} kind={kind} />
              <span className="inv-pending-files__name" title={file.name}>
                {file.name}
                <small>{formatFileSize(file.size)}</small>
              </span>
              <button
                type="button"
                className="inv-pending-files__remove"
                disabled={disabled}
                onClick={() => onRemoveFile(file)}
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      )}

      <button
        type="button"
        className="inv-add-more"
        disabled={disabled || !canAddMore}
        onClick={onAddBox}
      >
        {addMoreLabel}
      </button>
    </div>
  );
}
